import useShoppingCartContext from '../useShoppingCartContext';
export default function useShoppingCartContent() {
  var ctx = useShoppingCartContext();
  return [ctx.cart, ctx.setSubject];
}